import styles from './breadcrumbs.module.scss';
import MaterialBreadcrumbs from '@mui/material/Breadcrumbs';
import { ReactNode } from 'react';

/* eslint-disable-next-line */
export interface BreadcrumbsProps {
  children: any,
  // classes?: object,
  // component?: any,
  // expandText?: string,
  itemsAfterCollapse?: number,
  itemsBeforeCollapse?: number,
  maxItems?: number,
  separator?: ReactNode,
  // sx?: any,
  className?: string
}

export function Breadcrumbs(props: BreadcrumbsProps) {
  return (
    <MaterialBreadcrumbs
      className={props.className}
      itemsAfterCollapse={props.itemsAfterCollapse}
      itemsBeforeCollapse={props.itemsBeforeCollapse}
      maxItems={props.maxItems}
      separator={props.separator}>
      {props.children}
    </MaterialBreadcrumbs>
  );
}

export default Breadcrumbs;